


import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterUserViewAdd.module.scss";
import {
    useCreateEnquiryResponseMutation,
    useUpdateEnquiryResponseMutation,
} from "../../slices/admin/admin";

const HelpCenterUserAdminAdd = ({
    onClose,
    enquiryId,
    editData,
}) => {

    const isEdit = !!editData;

    const [modeOfContact, setModeOfContact] = useState("");
    const [status, setStatus] = useState("");
    const [comments, setComments] = useState("");
    const [errors, setErrors] = useState({});

    const [createResponse] = useCreateEnquiryResponseMutation();
    const [updateResponse] = useUpdateEnquiryResponseMutation();

    useEffect(() => {
        if (editData) {
            setModeOfContact(editData.modeOfContact || "");
            setStatus(editData.status || "");
            setComments(editData.comments || "");
        }
    }, [editData]);

    const handleSubmit = async () => {
        let newErrors = {};

        if (!modeOfContact) newErrors.modeOfContact = "Mode of Contact is required";
        if (!status) newErrors.status = "Status is required";
        if (!comments.trim()) newErrors.comments = "Comments is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        try {
            if (isEdit) {
                await updateResponse({
                    id: editData._id,
                    body: { comments, status },
                }).unwrap();
            } else {
                await createResponse({
                    enquiryId,
                    comments,
                    status,
                    modeOfContact,
                }).unwrap();
            }

            onClose();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div>
            <div className={styles.header}>
                <h2 className={styles.tittle}>
                    {isEdit ? "Update Ticket Response" : "Create Ticket Response"}
                </h2>
                <span className={styles.closeIcon} onClick={onClose}>✕</span>
            </div>

            <div className={styles.AddLedgerEntryformSection}>
                <div className={styles.dflex}>
                    <div className={styles.widthone}>
                        <div className={styles.ownerinput}>
                            <label className={styles.inputLabelssss}>
                                Mode of Contact
                            </label>
                            <select
                                className={styles.inputsheader}
                                value={modeOfContact}
                                onChange={(e) => setModeOfContact(e.target.value)}
                                disabled={isEdit}
                            >
                                <option value="">Select</option>
                                {/* <option value="online">Online</option> */}
                                {/* <option value="online">Online</option> */}
                                <option value="email">Email</option>
                                <option value="phone">Phone Call</option>
                            </select>
                            {errors.modeOfContact && (
                                <p className={styles.errorText}>{errors.modeOfContact}</p>
                            )}
                        </div>
                    </div>

                    <div className={styles.widthone}>
                        <div className={styles.ownerinput}>
                            <label className={styles.inputLabelssss}>Status</label>
                            <select
                                className={styles.inputsheader}
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                            >
                                <option value="">Select</option>
                                <option value="pending">Pending</option>
                                <option value="inprogress">In Progress</option>
                                <option value="completed">Completed</option>
                            </select>
                            {errors.status && (
                                <p className={styles.errorText}>{errors.status}</p>
                            )}
                        </div>
                    </div>
                </div>

                <div className={styles.ownerinput}>
                    <label className={styles.inputLabelssss}>Comments</label>
                    <textarea
                        className={styles.inputlastone}
                        value={comments}
                        placeholder="Enter Your Comments"
                        onChange={(e) => setComments(e.target.value)}
                    />
                    {errors.comments && (
                        <p className={styles.errorText}>{errors.comments}</p>
                    )}
                </div>
            </div>

            <div className={styles.ownerinputs}>
                <button className={styles.cancelBtnlast} onClick={onClose}>
                    Cancel
                </button>
                <button className={styles.saveBtnlast} onClick={handleSubmit}>
                    {isEdit ? "Update" : "Add"}
                </button>
            </div>
        </div>
    );
};

export default HelpCenterUserAdminAdd;

